import React from 'react';
import { useParams } from 'react-router-dom';

import AuthByCodePage from '../AuthByCode';

export default function RestorePasswordAuth() {
    const { code } = useParams();

    return <AuthByCodePage code={code} redirectTo="/s/account/change-password" />;
}
